import { useEffect, useState } from "react";
import { getShotsForCourseHole, summarizeGlobalWindForHole } from "@/lib/data/firestoreDAL";

type Props = { courseId: string; hole: number };

export default function WindAnalytics({ courseId, hole }: Props) {
  const [loading, setLoading] = useState(false);
  const [summary, setSummary] = useState<any>(null);

  useEffect(() => {
    let cancelled = false;

    (async () => {
      setLoading(true);
      const shots = await getShotsForCourseHole(courseId, hole, 1000);
      if (cancelled) return;

      const windSummary = summarizeGlobalWindForHole(shots);
      setSummary(windSummary);
      setLoading(false);
    })();

    return () => {
      cancelled = true;
    };
  }, [courseId, hole]);

  if (loading) return <div>Loading wind analytics...</div>;
  if (!summary) return <div>No wind data yet.</div>;

  return (
    <div className="border border-slate-700 rounded-xl bg-slate-800/60 p-4">
      <h2 className="text-lg font-semibold mb-2">Global Wind — Hole {hole}</h2>
      <p>Total Samples: {summary.totalCount}</p>
      <p>Avg Wind Speed: {summary.avgWindSpeedMph.toFixed(1)} mph</p>

      <div className="mt-4 space-y-1">
        {summary.bins.map((b: any) => (
          <div key={b.bin} className="flex justify-between text-sm">
            <span>{b.directionRange}°</span>
            <span>{b.count}</span>
          </div>
        ))}
      </div>
    </div>
  );
}